import type { SVGProps } from 'react';
const SvgMaterialDownload = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path
      fill="currentColor"
      d="M12 14.367a1 1 0 0 1-.353-.058.8.8 0 0 1-.306-.2L7.95 10.716a.86.86 0 0 1-.271-.659 1 1 0 0 1 .27-.66.96.96 0 0 1 .672-.293.88.88 0 0 1 .671.27l1.766 1.766V4.407q0-.4.271-.67.272-.272.671-.272t.672.271a.9.9 0 0 1 .27.67v6.735l1.766-1.766a.88.88 0 0 1 .672-.271q.388.012.67.295a1 1 0 0 1 .271.66.86.86 0 0 1-.27.658l-3.392 3.391a.8.8 0 0 1-.306.2q-.165.06-.353.06m-5.651 4.168q-.777 0-1.33-.553a1.82 1.82 0 0 1-.554-1.33v-1.884q0-.4.271-.671.272-.27.67-.271.4 0 .672.271a.9.9 0 0 1 .27.67v1.884h11.303v-1.883q0-.4.272-.671.27-.27.67-.271.4 0 .672.271a.9.9 0 0 1 .27.67v1.884q0 .777-.553 1.331a1.8 1.8 0 0 1-1.33.553z"
    />
  </svg>
);
export default SvgMaterialDownload;
